import content from '../content.json';
const pub = process.env.PUBLIC_URL;
const d = content.yourDesignRetreat;

export default function YourDesignRetreat() {
  return (
    <section style={{ background: '#ffffff', padding: '100px 0' }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto', padding: '0 48px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
        <div className="reveal">
          <span className="section-label">{d.label}</span>
          <h2 className="section-title">{d.title}</h2>
          <div className="gold-line" />
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', lineHeight: 1.9, color: 'var(--text2)', marginBottom: '32px' }}>{d.text}</p>
          <a href="#rooms" style={{ display: 'inline-block', fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--text)', border: '1px solid var(--text)', padding: '12px 28px', transition: 'all 0.25s' }}
            onMouseEnter={e => { e.target.style.background='var(--text)'; e.target.style.color='white'; }}
            onMouseLeave={e => { e.target.style.background='transparent'; e.target.style.color='var(--text)'; }}
          >Discover rooms</a>
        </div>
        <div className="reveal delay-2" style={{ overflow: 'hidden' }}>
          <img src={`${pub}/${d.image}`} alt="Silverkammer" style={{ width: '100%', height: '500px', objectFit: 'cover', transition: 'transform 0.6s ease' }}
            onMouseEnter={e => e.target.style.transform='scale(1.03)'}
            onMouseLeave={e => e.target.style.transform='scale(1)'}
          />
        </div>
      </div>
    </section>
  );
}
